import UpgradeToPro from "components/tool-tips/tips/upgradeToPro";
import InputLock from "components/tool-tips/tool/input-lock";
import Typography from "components/typography";
import React, { useMemo, useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import ArtistItem from "./artistItem";
import Modal from "components/modal";

import CreateArtistModal from "components/modal/modals/createArtist";
import SuccessModal from "components/modal/modals/successModal";
import LoadingModal from "components/modal/modals/loadingModal";
import {
  GetActiveArtist,
  GetUser,
  GetUserArtists
} from "services/user/getUser";
import { useDispatch } from "react-redux";
import { setActiveArtist } from "../../../../../redux/features/activeArtist/index";

const PlanArtists = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeModal, setActiveModal] = useState("add");
  const dispatch = useDispatch();
  const user = GetUser();

  const AddDisabled = useMemo(() => {
    if (user?.subscription === "free") {
      return true;
    }

    if (
      user?.subscription === "independent" &&
      user.artistProfiles &&
      user.artistProfiles?.length > 1
    ) {
      return true;
    }
    if (
      user?.subscription === "independent" &&
      user.artistProfiles &&
      user.artistProfiles?.length === 2
    ) {
      return true;
    }

    if (
      user?.subscription === "pro" &&
      user.artistProfiles &&
      user.artistProfiles?.length === 100
    ) {
      return true;
    }

    return false;
  }, [user]);

  const OnAddArtist = async (loading: boolean, success?: boolean) => {
    if (success && !loading) {
      setActiveModal("success");
    }
    if (loading) {
      setActiveModal("loading");
    }
    if (!loading) {
      setActiveModal("add");
    }
  };

  const PlanArtistsData = GetUserArtists();
  const ActiveArtist = GetActiveArtist();

  return (
    <Container>
      <Header>
        <Typography weight="medium" size="2xl">
          Plan Artists
        </Typography>
        <AddArtistButton
          notallowed={AddDisabled ? "true" : "false"}
          onClick={() => {
            if (AddDisabled) return;
            setActiveModal("add");
            setShowModal(true);
          }}
        >
          <Typography color={Colors.grey500} mr={AddDisabled ? "0.8" : "0"}>
            ADD NEW ARTIST
          </Typography>
          {AddDisabled && <InputLock tip={<UpgradeToPro artistVariant />} />}
        </AddArtistButton>
      </Header>
      <Items>
        {PlanArtistsData.map((artist, i) => {
          return (
            <ArtistItem
              value={artist.id === ActiveArtist?.id}
              name={artist.name}
              setActiveArtist={() => dispatch(setActiveArtist(artist.id))}
              key={i}
            />
          );
        })}
      </Items>
      {showModal && (
        <Modal isActive={showModal} closeModal={() => setShowModal(false)}>
          {activeModal === "add" ? (
            <CreateArtistModal
              close={() => setShowModal(false)}
              confirm={(loading: boolean, success?: boolean) =>
                OnAddArtist(loading, success)
              }
            />
          ) : activeModal === "loading" ? (
            <LoadingModal heading="Creating New Artist" />
          ) : activeModal === "success" ? (
            <SuccessModal
              heading="Artist Created "
              confirmText="Start Releasing With Artist"
              close={() => setShowModal(false)}
              confirm={() => setShowModal(false)}
            />
          ) : (
            <></>
          )}
        </Modal>
      )}
    </Container>
  );
};

export default PlanArtists;

const Container = styled.div`
  width: 100%;
  background-color: rgba(30, 30, 30, 0.8);
  border-radius: 0.8rem;

  padding: 2.4rem;
`;

const Header = styled.div`
  padding-bottom: 1.6rem;
  width: 100%;
  border-bottom: 0.5px solid ${Colors.grey600};
  margin-bottom: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const AddArtistButton = styled.div<{ notallowed: string }>`
  border-radius: 0.8rem;
  padding: 1.2rem;
  border: 0.5px solid ${Colors.grey500};
  display: flex;
  align-items: center;
  cursor: ${(props) =>
    props.notallowed === "true" ? "not-allowed" : "pointer"};
`;

const Items = styled.div`
  border: 0.5px solid ${Colors.grey600};
  border-top: none;
  border-radius: 0.6rem;
  :first-child {
    border-radius: 0.6rem;
  }
`;
